import { render, staticRenderFns } from "./TableCellDisplayOrder.vue?vue&type=template&id=48d8379d&scoped=true"
import script from "./TableCellDisplayOrder.vue?vue&type=script&lang=js"
export * from "./TableCellDisplayOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8379d",
  null
  
)

export default component.exports